import { makeVar } from 'react-reactive-var'

export const testVar = makeVar<number>(0)
